<template>
    <div v-if="company" class="animated fadeIn">
      <b-modal id="archive"  title="Подтвердите действие" ok-variant="danger" ok-only ok-title="Понятно">
        Компания отправлена в Архив.
      </b-modal>
      <FinanceResult :company="company" :report="report"/>
      <div v-if="!report.report_data">
        <b-row>
          <b-col sm="6" class="mx-auto">
              <b-card>
            <div slot="header">
              <strong>Диагностика компании </strong>&laquo;<small>{{company.name}}&raquo;(ОГРН {{company.ogrn}})</small>
            </div>
            <form @submit.prevent="saveConfirm({isSend: true})">
              <b-form-group class="text-center">
                <b-button type="submit" variant="success">
                  <i class="fa fa-dot-circle-o"></i>
                  Провести проверку
                </b-button>
              </b-form-group>
            </form>
          </b-card>
          </b-col>
        </b-row>
      </div>
      <div v-else>
        <b-row>
          <b-col>
            <b-card>
              <div slot="header">
                <ul class="list-group pull-right">
                  <li class="list-group-item py-2" :class="'list-group-item-' + report.status">
                    {{ report.status_crm }}
                  </li>
                </ul>
                <strong>Диагностика компании </strong>&laquo;<small>{{company.name}}&raquo;(ОГРН {{company.ogrn}})</small> <directory slug="etap-diagnostiki-ekspress-fin" />
              </div>
              <b-table hover :fields="tableFields" :items="report.report_data.params">
                <template :slot="tableFields[1].key" slot-scope="scope">
                  <span v-if="scope.item[tableFields[1].key] === false" class="badge badge-secondary">Нет данных</span>
                  <span v-else>{{scope.item[tableFields[1].key]}}</span>
                </template>
                <template :slot="tableFields[2].key" slot-scope="scope">
                  <span v-if="scope.item[tableFields[2].key] === false" class="badge badge-secondary">Нет данных</span>
                  <span v-else>{{scope.item[tableFields[2].key]}}</span>
                </template>
                <template :slot="tableFields[3].key" slot-scope="scope">
                  <span v-if="scope.item[tableFields[3].key] === false" class="badge badge-secondary">Нет данных</span>
                  <span v-else>{{scope.item[tableFields[3].key]}}</span>
                </template>
                <template :slot="tableFields[4].key" slot-scope="scope">
                  <span v-if="scope.item[tableFields[4].key] === false" class="badge badge-secondary">Нет данных</span>
                  <span v-else>{{scope.item[tableFields[4].key]}}</span>
                </template>
                <template slot="points" slot-scope="scope">
                  <span v-if="scope.item.points === false" class="badge badge-danger">Ошибка!</span>
                  <span v-else>{{scope.item.points}}</span>
                </template>
              </b-table>
              <div class="pull-right">
                <h5 v-if="report.report_data.total !== false">Общий балл: {{report.report_data.total}}</h5>
                <h5 v-else>Общий балл: <span class="text-danger">ошибка расчета</span></h5>
              </div>
              <div slot="footer">
                <button @click="print" v-if="report.status !== 'secondary'" type="button" class="btn btn-primary btn-sm text-white pull-right">
                  <i class="fa fa-print"></i>
                  Распечатать
                </button>
              </div>
            </b-card>
          </b-col>
        </b-row>
      </div>
    </div>
</template>

<script>
    import { eventHub } from '../utils/eventhub'
    import client from '../backend/client';
    import { Switch as cSwitch } from '@coreui/vue';
    import FinanceResult from "./FinanceResult";
    import Directory from "../components/Directory.vue";
    export default {
        name: "DiagnostFinance2",
        props: ['companyId'],
        components: {
          Directory,
            FinanceResult,
            cSwitch
        },
        data: () => {
            return {
                company: null,
                accounting: [],
                report: null,
                rawData: {},
                currentYear: new Date().getMonth()+1 >= 4 ? new Date().getFullYear() : new Date().getFullYear() - 1,
                tableFields: [],
            }
        },
        mounted() {
          eventHub.$on('report:reload', () => {
            this.load()
          })
          this.load()
        },
        methods: {
            load() {
              if(this.company) {
                this.id = this.companyId;
              } else {
                this.id = this.$route.params.id;
              }

              this.tableFields.push({
                key: 'title',
                label: 'Название параметра'
              });
              for (let i = 4; i >= 1; i--) {
                this.tableFields.push({
                  key: (this.currentYear - i).toString()
                });
              }
              this.tableFields.push({
                key: 'points',
                label: 'Баллы'
              });
              client
                .get('api/enrolls/' + this.id + '/company')
                .then((res) => {
                  this.company = res.data;
                  this.report = this.company.enroll.reports.finance_express_report;
                })
              ;
            },
            saveConfirm(params) {
              this.updateReport(params);
            },
            updateReport(params) {
                return client
                    .put('api/crm/enrollreports/' + this.report.id, params)
                    .then(res => {
                        this.report = res.data;
                        eventHub.$emit('finance_report', ['success', 'warning', 'secondary'].indexOf(this.report.status) > -1);
                        if(this.report.status === 'danger') {
                          this.$bvModal.show('archive');
                        }
                    })
            },
            print() {
                let block = window.open('', 'PRINT');
                block.document.write('<html><head>');
                block.document.write('<style>@page { size: portrait;}</style>');
                block.document.write('</head><body>');
                block.document.write(document.getElementById('print-report').innerHTML);
                block.document.write('</body></html>');
                block.document.close();
                block.focus();
                block.print();
                block.close();
                return true;
            }
        }
    }
</script>

<style scoped>
  .container  {
    display: flex;
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
  }

  .container .row {
    margin: 0 auto;
  }
</style>
